import PropTypes from 'prop-types';
import { useState, useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
// import useAuth from '../hooks/useAuth';
// pages
// import Login from '../pages/auth/Login';
// components
import LoadingScreen from 'components/LoadingScreen';
import {PATH} from 'routes/paths';
import { AuthContext } from "context/AuthContext";

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  // const navigate = useNavigate();

  const { isAuthenticated, isInitialized } = useContext(AuthContext);

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }
  if (!isAuthenticated) {
    // console.log("Please Login");
    return <Navigate to={PATH.login} />;
  }

  
  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
